import { render, staticRenderFns } from "./kmLogin.vue?vue&type=template&id=bd821854&scoped=true"
import script from "./kmLogin.vue?vue&type=script&lang=js"
export * from "./kmLogin.vue?vue&type=script&lang=js"
import style0 from "./kmLogin.vue?vue&type=style&index=0&id=bd821854&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd821854",
  null
  
)

export default component.exports